import { useQuery } from '@apollo/client'

import SUBSCRIPTION_PLAN_QUERY from './get-subscription-plan.graphql'

interface UserSubscription {
  me: {
    id
    email: string
    subscriptionPlan: {
      id: string
      code: string
    }
  }
}

export const useUserSubscription = (userId) => {
  const { data, loading } = useQuery<UserSubscription>(
    SUBSCRIPTION_PLAN_QUERY,
    {
      skip: !userId,
    }
  )

  const subscriptionPlanCode = data?.me?.subscriptionPlan?.code
  const userEmail = data?.me?.email

  return {
    userEmail,
    subscriptionPlanCode,
    loading,
  }
}
